<template>
  <v-card id="document-list" class="my-2">
    <v-card-title>
      <div class="d-flex align-center">
        <v-btn elevation="1" class="mr-3" fab small @click="TOGGLE_CLOSED_BLOCK('laboratory')" color="white">
          <v-icon>
            mdi-dots-vertical
          </v-icon>
        </v-btn>
        <h2>Лабораторные исследования</h2>
      </div>
    </v-card-title>
    <div v-if="isShow" class="position-relative">
      <Loader ref="tableLoader" block />

      <v-data-table
        :headers="headers"
        :items="items"
        :loading="loading"
        :options.sync="options"
        :server-items-length="meta.total"
        @click:row="showItem"
      >
        <template v-slot:top>
          <v-container fluid>
            <v-row no-gutters>
              <v-col cols="12" sm="3" class="mr-3">
                <date-range-picker v-model="filter.date" @input="load" dense />
              </v-col>
            </v-row>
          </v-container>
        </template>

        <template v-slot:item.attachments="{ item }">
          <div
            @click.prevent="
              e => {
                e.stopPropagation();
              }
            "
          >
            <attachment-list-viewer :attachments="item.attachments" />
          </div>
        </template>
        <template v-slot:item.doctor_sign="{ item }">
          <v-btn small disabled v-if="item.doctor_sign">Подписан</v-btn>
          <v-btn small v-else @click.stop="signItem(item)">Подписать</v-btn>
        </template>

        <!--
        <template v-slot:item.actions="{ item }">
        </template>
        -->
      </v-data-table>
    </div>
  </v-card>
</template>

<script>
import throttle from "lodash/throttle";
import { QueryHelper } from "@/services/query-helper";
import DateRangePicker from "@/components/forms/DateRangePicker";
import { DocumentsService } from "@/services/api/documents.service";
import AttachmentListViewer from "@/views/components/AttachmentListViewer";
import { CustomerService } from "@/services/api/customer.service";
import AddDocument from "@/modules/documents/add-document/AddDocument.vue";
import SignDocument from "@/modules/documents/add-document/SignDocument.vue";
import { FLAGS } from "@/configs";
import Loader from "@/components/Loader.vue";
import { mapMutations, mapState } from "vuex";
export default {
  name: "DocumentList",
  components: { Loader, AttachmentListViewer, DateRangePicker },
  data: () => ({
    loading: true,
    options: {},
    search: "",
    meta: {
      total: 0,
    },
    filter: {
      date: [],
      type: "",
    },
    documentsTypes: [],
    headers: [
      { text: "Документ", value: "name", sortable: true },
      { text: "Тип документа", value: "type", sortable: false },
      { text: "Дата выдачи", value: "date", sortable: true },
      { text: "Автор", value: "author", sortable: false },
      { text: "№ заказа", value: "number", sortable: false },
      { text: "Подписан", value: "doctor_sign", sortable: false },
      { text: "Вложения", value: "attachments", sortable: false },
      // { value: 'actions', sortable: false },
    ],
  }),

  computed: {
    ...mapState("ikp", ["closedBlocks"]),
    isShow() {
      return !this.closedBlocks.includes("laboratory");
    },
    customerId() {
      return this.$store.state.customer.id;
    },

    doctorId() {
      return this.$store.state.auth.id;
    },

    items() {
      return this.$store.state.documents.items;
    },
  },

  watch: {
    options: {
      handler() {
        this.load();
      },
      deep: true,
    },
  },

  async created() {
    this.documentsTypes = await DocumentsService.getTypes();

    if (this.$route.name === "document" && this.$route.params.id) {
      this.$dialog.notify.info(`Документ №${this.$route.params.id} идет загрузка...`);
      this.showItem({ id: this.$route.params.id });
    }
  },

  methods: {
    ...mapMutations("ikp", ["TOGGLE_CLOSED_BLOCK"]),

    async load() {
      this.loading = true;
      try {
        const params = {
          search: this.search,
          "filter[type]": 2,
          ...QueryHelper.tableSorting(this.options),
          ...QueryHelper.pagination(this.options, this.meta.total),
        };
        const response = await this.$http.get(`v1/customers/${this.customerId}/documents`, { params }).then(r => r.data);
        this.meta.total = response.meta.total;
        this.$store.commit("documents/SET_ITEMS", response.data);
      } catch (e) {
        // TODO: Обработать ошибку
        console.error(e);

        this.$store.commit("documents/SET_ITEMS", []);
        this.meta.total = 0;
      }

      this.loading = false;
    },

    apiSearch: throttle(async function apiSearchHandler() {
      await this.load();
    }, 1000),

    /**
     * @param {CustomerDocumentItem} item
     * @return {Promise<void>}
     */
    async showItem(item) {
      this.$refs.tableLoader.show();

      try {
        const r = await CustomerService.getDocument(this.customerId, item.id);

        const isUpdated = await this.$dialog.showAndWait(AddDocument, {
          customerForm: r,
          readonly:
            !!r.doctor_sign ||
            (this.doctorId !== r.author.id && !this.$featureFlags.feature(FLAGS.DISABLE_CHECK_DOCUMENT_AUTHOR).enabled),
          width: 600,
          doctorId: this.doctorId,
          persistent: true,
        });

        if (isUpdated) {
          this.load();
        }
      } catch (e) {
        if (e?.response.status === 404) {
          this.$dialog.notify.error(`Документ №${item.id} не найден`);
        } else {
          this.$dialog.notify.error("Не удалось загрузить документ");
        }
      }

      this.$refs.tableLoader.hide();
    },

    async signItem(item) {
      this.$refs.tableLoader.show();
      try {
        const r = await CustomerService.getDocument(this.customerId, item.id);
        const isUpdated = await this.$dialog.showAndWait(SignDocument, {
          customerForm: r,
          readonly:
            !!r.doctor_sign ||
            (this.doctorId !== r.author.id && !this.$featureFlags.feature(FLAGS.DISABLE_CHECK_DOCUMENT_AUTHOR).enabled),
          width: 600,
          persistent: true,
        });

        if (isUpdated) {
          this.load();
        }
      } catch (e) {
        console.log(`e =>`, e);
        if (e?.response?.status === 404) {
          this.$dialog.notify.error(`Документ №${item.id} не найден`);
        } else {
          this.$dialog.notify.error("Не удалось загрузить документ");
        }
      }
      this.$refs.tableLoader.hide();
    },
    async deleteItem(item) {
      const title = item.name ? `"${item.name}"` : "";
      const result = await this.$dialog.confirm({
        title: "Удаление документа",
        text: `Вы подтверждаете удаление документа ${title}`,
      });

      if (result) {
        this.loading = true;
        await this.$store.dispatch("documents/removeItem", item);
        this.meta.total--;
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.attachment-icon {
  transform: rotate(-90deg);
}
</style>
